import { render } from "./AuctionsByCompanyView.vue?vue&type=template&id=5f20a2b1&scoped=true&ts=true"
import script from "./AuctionsByCompanyView.vue?vue&type=script&lang=ts"
export * from "./AuctionsByCompanyView.vue?vue&type=script&lang=ts"

import "./AuctionsByCompanyView.vue?vue&type=style&index=0&id=5f20a2b1&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f20a2b1"]])

export default __exports__